<div class="row">
  <div class="col-12">
    <sb-card [loading]="loading">
      <div card-fit>
        <sb-wizard [hideTabs]="true">
          <sb-wizard-tab titleText="{{ 'lang.wizard.tabs.generalSettings' | translate }}" icon="basicSettings"
                         [active]="true">
            <form [formGroup]="form" class="wizard__forms p-5">
              <h3 class="my-4">{{ 'lang.tagEdit.tagDetails' | translate }}</h3>
              <div class="row">
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-12">
                      <div class="form-group validateMe">
                        <label class="form-label" for="Title">{{ 'lang.globals.name' | translate }}</label>
                        <input type="text" id="Title" class="form-control" formControlName="Name">
                        <span class="form-text text-muted">{{ 'lang.globals.nameDescription' | translate }}</span>
                        <div *ngIf="Name.touched && Name.errors?.required"
                             class="alert alert-danger">{{ 'lang.globals.nameWarning' | translate }}
                        </div>
                      </div>
                    </div>
                    <div class="col-12">
                      <div class="form-group validateMe">
                        <label class="form-label" for="Description">{{ 'lang.globals.description' | translate }}</label>
                        <input type="text" id="Description" class="form-control" formControlName="Description">
                        <span class="form-text text-muted">{{ 'lang.planningEdit.description' | translate }}</span>
                        <div *ngIf="Description.touched && Description.errors?.required"
                             class="alert alert-danger">{{ 'lang.planningEdit.description' | translate }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <span *ngIf="tag" [style.background]="tag.color" [cpToggle]="true" [cpDialogDisplay]="'inline'"
                        [colorPicker]="'#' + tag.color"
                        (colorPickerChange)="setColor($event)"
                  ></span>
                </div>
              </div>
              <div class="wizard__footerActions">
                <button (click)="util.returnToNavigation(util.RoutingID.tags)" type="button"
                        class="btn btn-default btn-lg btn-wide">{{ 'lang.globals.cancel' | translate }}
                </button>
                <button (click)="updateTagCall()" [disabled]="!form.valid || loading"
                        class="btn btn-success btn-wide btn-lg">{{ 'lang.globals.submit' | translate }}
                </button>
              </div>
            </form>
          </sb-wizard-tab>
        </sb-wizard>

      </div>
    </sb-card>
  </div>
</div>
